import { createFileRoute } from '@tanstack/react-router'
import { CustomerChrome } from '#bv/components/customer/CustomerChrome'

export const Route = createFileRoute('/customer/rewards')({
  component: CustomerRewardsPage,
})

function CustomerRewardsPage() {
  return (
    <CustomerChrome active="rewards" title="Rewards" subtitle="Invite and boost tracking (coming soon).">
      <div className="rounded-2xl border border-white/[0.06] p-5 sm:p-6" style={{ background: 'rgba(10,8,16,0.8)' }}>
        <div className="flex flex-col items-center py-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full" style={{ background: 'linear-gradient(135deg, rgba(0, 191, 255,0.08), rgba(139,92,246,0.06))' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#93c5fd" strokeWidth="1.5"><circle cx="12" cy="8" r="7" /><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" /></svg>
          </div>
          <h2 className="m-0 mt-4 text-lg font-extrabold text-[#f0f6ff]">Invite rewards</h2>
          <p className="m-0 mt-2 max-w-[320px] text-sm text-[#5a6d8a]">
            Earn credits by inviting friends and boosting our Discord server. Connect your account to start tracking.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-xl border border-white/[0.06] bg-white/[0.02] px-4 py-2 text-xs font-semibold text-[#5a6d8a]">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
            Coming soon
          </div>
        </div>
      </div>

      <div className="mt-5 grid gap-3 sm:grid-cols-3">
        {[
          { title: 'Invite friends', desc: 'Share your referral link and earn credits for each sign-up.', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#93c5fd" strokeWidth="1.5"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg> },
          { title: 'Boost server', desc: 'Server boosts unlock higher tiers and bonus rewards.', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> },
          { title: 'Earn credits', desc: 'Use credits towards purchases in Pulse Shop.', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="1.5"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> },
        ].map((card) => (
          <div key={card.title} className="rounded-xl border border-white/[0.06] p-4" style={{ background: 'rgba(0,0,0,0.15)' }}>
            <div className="flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: 'rgba(0, 191, 255,0.06)' }}>
              {card.icon}
            </div>
            <p className="m-0 mt-3 text-sm font-semibold text-[#f0f6ff]">{card.title}</p>
            <p className="m-0 mt-1 text-xs text-[#5a6d8a]">{card.desc}</p>
          </div>
        ))}
      </div>
    </CustomerChrome>
  )
}
